import { lazy } from '@/service/lazy'

export default [{
  name: 'Comunicados',
  path: 'comunicado',
  id: 'comunicado',
  icon: 'fa fa-exclamation-triangle',
  component: lazy('app/default/gerenciador/comunicado/index'),
  meta: { requireAuth: true, rules: ['gerenciar_comunicado'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/comunicado.js